import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10.3284 7.13886C10.1693 6.91003 9.83074 6.91003 9.67161 7.13886L6.18701 12.1494C6.00256 12.4146 6.19235 12.7778 6.5154 12.7778L13.4846 12.7778C13.8076 12.7778 13.9974 12.4146 13.813 12.1494L10.3284 7.13886Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }